import { AdminListUI } from './AdminListUI';

export default function GovernmentIntakeAdminListView() {
  return <AdminListUI />;
}
